import { MarketplaceBuildingPriceDto } from "../../../../../../networking/data/responses/marketplace/MarketplaceBuildingPriceDto";

export class MarketplaceBuildingPrice {
    public readonly usd?: number;
    public readonly mon?: number;

    public constructor(priceDto: MarketplaceBuildingPriceDto) {
        this.usd = priceDto.usd;
        this.mon = priceDto.mon;
    }
}
